import { pn, replaceSpacesWithUnderscores } from "@compass/core";
import { AprResponsePostsecondaryEnrollment, AprResponsePostsecondaryPersistence, ReportPropertyBase } from "generated/openApi";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

import { DevExpressReport, renderReportColumn, renderReportSummary } from "components";
import "moment-timezone";

export const PostsecondaryPersistenceFpr = (props: { title: string; response: AprResponsePostsecondaryPersistence }) => {
  const appTenantName = useSelector((state: RootState) => state.app.tenantName);

  const onExporting = () => {
    return {
      header: props.title,
      filename: replaceSpacesWithUnderscores(props.title),
      tenantName: appTenantName,
    };
  };

  return (
    <DevExpressReport
      title={props.title}
      dataSource={props.response.rows}
      exportFormats={["pdf", "excel", "csv"]}
      onExporting={onExporting}
      fullPageSize
      showColumnChooser={false}
      showHeaderColumns={false}
    >
      {props.response.properties?.map((property) => {
        return renderReportColumn({
          property: property,
          propertyKey: pn<ReportPropertyBase>("propertyName"),
        });
      })}

      {renderReportSummary({
        properties: props.response.properties,
        propertyKey: pn<ReportPropertyBase>("propertyName"),
        hideLabel: true,
      })}
    </DevExpressReport>
  );
};
